import React, { Component } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import { Image } from "react-bootstrap";
import L from "leaflet";
import { ListarEntregadores } from "../../providers/EntregadorProvider";
import { api_url_estabelecimentos_image } from "../../providers/api";

import estabelecimentoAberto from "../../assets/estabelecimentoAberto.png";
import estabelecimentoFechado from "../../assets/estabelecimentoFechado.png";
import entregadorIndisponivel from "../../assets/entregadorIndisponivel.png";
import entregadorDisponivel from "../../assets/entregadorDisponivel.png";
import entregadorEmAtendimento from "../../assets/entregadorEmAtendimento.png";
import { ListarEstabelecimentos } from "../../providers/EstabelecimentoProvider";

const iconEstabelecimentoAberto = new L.Icon({
  iconUrl: estabelecimentoAberto,
  iconRetinaUrl: estabelecimentoAberto,
  iconSize: new L.Point(40, 40),
  popupAnchor: [-2, -16],
});

const iconEstabelecimentoFechado = new L.Icon({
  iconUrl: estabelecimentoFechado,
  iconRetinaUrl: entregadorEmAtendimento,
  iconSize: new L.Point(40, 40),
  popupAnchor: [-2, -16],
});

const iconEntregadorDisponivel = new L.Icon({
  iconUrl: entregadorDisponivel,
  iconRetinaUrl: entregadorEmAtendimento,
  popupAnchor: [-2, -20],
  iconSize: new L.Point(40, 40),
});

const iconEntregadorEmAtendimento = new L.Icon({
  iconUrl: entregadorEmAtendimento,
  iconRetinaUrl: entregadorEmAtendimento,
  popupAnchor: [-2, -20],
  iconSize: new L.Point(40, 40),
});

const iconEntregadorIndisponivel = new L.Icon({
  iconUrl: entregadorIndisponivel,
  iconRetinaUrl: entregadorIndisponivel,
  popupAnchor: [-2, -20],
  iconSize: new L.Point(40, 40),
});

export default class Mapa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: [-5.8296303, -35.2113399],
      zoom: 14,
      marcadores: [],
      marcadoresEstabelecimento: [],
    };
    this.mapRef = React.createRef();
  }

  listarEstabelecimentos = async () => {
    const { docs } = await ListarEstabelecimentos(1);
    let marcadores = [];
    docs.forEach((estab) => {
      marcadores.push({
        tipo: "estabelecimento",
        latitude: estab.endereco ? estab.endereco.latitude : 0,
        longitude: estab.endereco ? estab.endereco.longitude : 0,
        descricao: estab.nome_fantasia,
        imagem: estab.foto_estabelecimento,
        status: estab.status,
      });
    });
    this.setState({ marcadoresEstabelecimento: marcadores });
  };

  listarEntregadores = async () => {
    this.setState({ marcadores: [] });
    const response = await ListarEntregadores();
    let marcadores = [];
    response.forEach((entregador) => {
      if (entregador.localizacao) {
        marcadores.push({
          tipo: "entregador",
          latitude: entregador.localizacao ? entregador.localizacao.latitude : 0,
          longitude: entregador.localizacao ? entregador.localizacao.longitude : 0,
          descricao: entregador.nome,
          status: entregador.status,
          imagem: null,
        });
      }
    });
    this.setState({ marcadores });
  };

  async componentDidMount() {
    this.atualizar();
    await this.listarEstabelecimentos();
    await this.listarEntregadores();
  }

  mudarIconePorStatus = (tipo, status) => {
    if (tipo === "estabelecimento") {
      if (status === "Aberto") {
        return iconEstabelecimentoAberto;
      } else {
        return iconEstabelecimentoFechado;
      }
    }
    if (tipo === "entregador") {
      if (status === "disponivel") {
        return iconEntregadorDisponivel;
      } else if (status === "indisponivel") {
        return iconEntregadorIndisponivel;
      } else {
        return iconEntregadorEmAtendimento;
      }
    }
  };

  atualizar() {
    setInterval(async () => {
      await this.listarEntregadores();
    }, 60000);
  }

  componentDidUpdate() {
    if (this.mapRef.current) {
      this.mapRef.current.leafletElement.invalidateSize();
    }
  }

  render() {
    if (this.state.marcadores.length) {
      return (
        <Map
          ref={this.mapRef}
          center={this.state.center}
          zoom={this.state.zoom}
          style={{
            width: "96vw",
            height: "89vh",
          }}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
          />
          {this.state.marcadores
            .concat(this.state.marcadoresEstabelecimento)
            .map((marcador, index) => (
              <Marker
                key={index}
                position={[marcador.latitude, marcador.longitude]}
                icon={this.mudarIconePorStatus(marcador.tipo, marcador.status)}
              >
                <Popup>
                  {marcador.imagem ? (
                    <Image
                      rounded
                      style={{ width: 30, height: 30, marginRight: 3 }}
                      src={api_url_estabelecimentos_image + marcador.imagem}
                    ></Image>
                  ) : null}
                  <span>{marcador.descricao}</span>
                </Popup>
              </Marker>
            ))}
        </Map>
      );
    } else {
      return <div></div>;
    }
  }
}
